module.exports = __webpack_public_path__ + "static/media/plastico-visa-volar.47d1d5f8.png";